export default "__VITE_ASSET__Wb$CBppA__"